module.exports = __webpack_public_path__ + "img/Seguro-de-Vida.f05c484d.png";